import { StringParam } from 'use-query-params';

export const AppQueryParamsConfigMap = {
  c: StringParam, // class id
  e: StringParam, // event id
  t: StringParam,
  LocationID: StringParam, // location id
  SecretaryID: StringParam, // secretary id
  PCID: StringParam, // pony club id
  RCID: StringParam, // riding club id
};

export const TABLET_BREAKPOINT = 1000;
export const MOBILE_BREAKPOINT = 750;

export const BASE_API_URL = window.REACT_APP_API_URL;
